//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import parse from 'date-fns/parse'
import format from 'date-fns/format'

export default {
  props: ['featured'],

  computed: {

  },
  watch: {

  },
  components: {

  },
  data() {
    return { 
        activeSection: null,
        stories: localStories,
        sliderOptions: {
            initialIndex: 0,
            wrapAround: true,
            resize: true,
            setGallerySize: false,
            autoPlay: 3500
            // any options from Flickity can be used
        },
     
    }
  },
  mounted() {

      console.log('__LOCAL STORIES', this.stories)

  },
  methods: {
    printDate(dt, ps, fm) {
      console.log( '__PARSE___', parse(dt, ps, new Date()) );
      return format( parse(dt, ps, new Date()), fm );
    },
  }
}




// WEBPACK FOOTER //
// ./scripts/components/HomeLocalStories.vue